<template>
    <aside class='menu'>
        <p class='menu-label'>学校</p>
        <ul class='menu-list'>
            <li @click='toParamLink("/photographer")'><a>アップロード・個別設定</a></li>
            <li @click='toParamLink("/photographer/school")'><a>学校管理</a></li>
            <li @click='toParamLink("/photographer/basicSetting")'><a>デフォルト設定</a></li>
        </ul>
        <p class='menu-label'>保護者</p>
        <ul class='menu-list'>
            <li @click='toPhotobuy'><a>写真購入リンク</a></li>
            <li @click='toParamLink("/photographer/parent")'><a>保護者管理</a></li>
            <!-- <li @click='toParamLink("/photographer/parent/registerLink")'><a>保護者登録用リンク</a></li> -->
            <!-- <li @click='toParamLink("/photographer/parent/distribution")'><a>保護者配信機能</a></li> -->
        </ul>
        <p class='menu-label'>その他</p>
        <ul class='menu-list'>
            <li @click='toMypage'><a>ユーザー設定</a></li>
            <li @click='toParamLink("/photographer/order")'><a>注文一覧</a></li>
            <li @click='logout'><a class='has-text-danger'>ログアウト</a></li>
        </ul>
    </aside>
</template>

<script>

export default {
    name: 'Sidebar',
    components: {
    },
    data () {
        return {
        }
    },
    mounted () {
    },
    methods: {
        toMypage () {
            window.open(`/#/photobuy/mypage?to=profile`)
        },
        toPhotobuy () {
            window.open(`/#/photobuy/event/${this.$parent.selectEventId}`)
        },
        toParamLink (link) {
            if (this.getParamId()) link += `?id=${this.getParamId()}`

            this.$router.push(link)
        },
        getParamId () {
            return this.$route.query.id
        },
        logout () {
            this.$root.$emit('logout')
        }
    }
}
</script>

<style scoped>
.menu {
    min-height: calc(100vh - 80px);
    min-width: 230px;
    padding-top: 20px;
    padding-left: 18px;
    padding-bottom: 10px;
    background-color: #fafafa;
}

.menu-label {
    font-size: 15px;
}

a {
    font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/photographer/Sidebar.vue